import { useTranslation } from "react-i18next";
import "../styles/hero.css";

function Hero() {
  const { t, i18n } = useTranslation();

  const handleButtonClick = () => {
    window.location.href = "/future-page"; // Replace this with your desired URL
  };

  return (
    <section className={`hero-section ${i18n.language === "ar" ? "rtl" : ""}`}>
      {/* Hero Image Section */}
      <div className="hero-image"></div>

      {/* Hero Content Section */}
      <div className="hero-content">
        <h1 className="hero-title">{t("hero.slogan")}</h1>
        <button className="hero-button" onClick={handleButtonClick}>
          {t("hero.learnMore")}
        </button>
      </div>
    </section>
  );
}

export default Hero;
